import { ApiAnnouncementService } from ".";
import { AxiosResponse } from 'axios';
import { HttpMethods } from "../httpMethods";
import { Controllers, AnnouncementApiRoutes, GeneralRoutes, AnnouncementMediaApiRoutes } from "../../utils/constants";
import { DeleteBlobEntity, UpdateAnnouncementDto, AudioFileGenerateDto, DynamicAnnouncementDto, AnnouncementDto } from "../../types/announcement";
import { BaseService } from "../baseService";

export class AnnouncementService extends BaseService implements ApiAnnouncementService {
    async getAnnouncements(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.Announcements, urlParams);
    }
    async getDynamicAnnouncements(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.DynamicAnnouncements, urlParams);
    }
    async getAllForTenant(tenantId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.GetAll, `?tenantId=${tenantId}`);
    }

    async getMaxNumberOfAnnouncements(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.GetMaxNumberOfAnnouncements);
    }

    async getMaxMediaFileSize(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.AnnouncementMedia, AnnouncementMediaApiRoutes.GetMaxMediaFileSize);
    }

    async getAnnouncementById(announcementId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, '', `${announcementId}`);
    }

    async getCollectionType(announcementId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.GetCollectionType, `?id=${announcementId}`);
    }

    async getDynamicAnnouncementById(announcementId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, AnnouncementApiRoutes.GetDynamic, `?id=${announcementId}`);
    }

    async getAnnouncementsByType(urlParams: string, hasText: boolean = false, includeUntyped: boolean = true): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Announcement, '', `${urlParams}?hasText=${hasText}&includeUntyped=${includeUntyped}`);
    }

    async createAnnouncement(announcement: UpdateAnnouncementDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, GeneralRoutes.Create, null, announcement);
    }

    async createDynamicAnnouncement(announcement: DynamicAnnouncementDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, AnnouncementApiRoutes.CreateDynamic, null, announcement);
    }

    async updateAnnouncement(schedule: UpdateAnnouncementDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, AnnouncementApiRoutes.Announcements, null, schedule);
    }

    async updateDynamicAnnouncement(announcement: DynamicAnnouncementDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, AnnouncementApiRoutes.DynamicAnnouncements, null, announcement);
    }

    async uploadToStorage(data: FormData): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AnnouncementMedia, AnnouncementMediaApiRoutes.UploadToStorage, null, data);
    }

    async deleteFromStorage(blob: DeleteBlobEntity): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AnnouncementMedia, AnnouncementMediaApiRoutes.DeleteFromStorage, null, blob);
    }

    async deleteAnnouncements(data: AnnouncementDto[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, GeneralRoutes.Delete, null, data);
    }

    async getLanguagesAndVoices(tenantId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.AnnouncementMedia, AnnouncementMediaApiRoutes.LanguagesAndVoices, `?tenantId=${tenantId}`);
    }

    async generateAudioFile(audioFileGenerateDto: AudioFileGenerateDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AnnouncementMedia, AnnouncementMediaApiRoutes.GenerateAudioFile, null, audioFileGenerateDto);
    }
    async deleteDynamicAnnouncements(data: DynamicAnnouncementDto[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Announcement, AnnouncementApiRoutes.DeleteDynamic, null, data);
    }
}